(function ($) {
    "use strict";
    $(function () {

        function checkHash() {
            if (window.location.hash) {

                var hash = window.location.hash.substring(1);
                var dom = $("div" + "#" + hash);

                $('html,body').animate({
                    scrollTop: dom.position().top + "px"
                }, 1000);

                return false;
            }
        }

        $(window).scroll(function () {
            var scrollTop = $(window).scrollTop();
            var stickyHeader = $(".navbar");

            if (scrollTop > 56) {
                $('.site-sentence').hide(100);
                $('.site-title').addClass('d-flex');
                stickyHeader.addClass('active');
            } else {
                $('.site-sentence').show(100);
                $('.site-title').removeClass('d-flex');
                stickyHeader.removeClass('active');
            }
        });

        /*ScrollTo*/
        $(".scroll").click(function (event) {
            var pageid = $(this).children('a').attr('href').substring(1);

            if (!$('#' + pageid).length) {
                window.location.href = adminAjax.phpBaseUrl + '/#' + pageid;
            }

            var dom = $("div" + "#" + pageid);

            $('.navbar-toggler').click();

            $("html, body").animate({
                scrollTop: dom.position().top + "px"
            }, 1000);
            event.preventDefault();

        });

        $('.input-holder input').click(function () {
            $('#wait-modal').modal('show');
        });

        $('.input-holder button').click(function () {
            $('#wait-modal').modal('show');
        });

        $('#header-next-btn').click(function () {
            $('#wait-modal').modal('show');
        });

        $('#wait-modal-close-x').click(function () {
            $('#wait-modal').modal('hide');
        })


    });
})(jQuery);
